export const TOOLTIP_DELAY = 500 as const;
export const ADD_ISSUE_TYPE_OPTION = 'add-issue-type-option';
